import config from 'assets/config.json';

export const BASE_URL = config.API_BASE_URL;

export const STUDY_FILTER_DATE_FORMAT = 'YYYYMMDD';

export const AUTH_ERROR_MESSAGE = 'Your session has expired'

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later.';
export const SESSION_ERROR_MESSAGE =
  'Your session has expired and was refreshed. Please try again.';
